/**
 * 管理者がユーザーを追加するためのAuthユーザー作成。
 *
 * クライアントSDKの createUserWithEmailAndPassword は、作成したユーザーで
 * ログインし直してしまう(管理者のセッションが奪われる)。
 * それを避けるため、使い捨ての副次Firebaseアプリを立てて作成し、すぐ破棄する。
 *
 * ※Cloud Functions を導入したら Admin SDK 経由に置き換える(フェーズ3で再検討)。
 */
import { deleteApp, initializeApp } from 'firebase/app';
import { createUserWithEmailAndPassword, getAuth, signOut } from 'firebase/auth';
import { getFirebaseConfig } from '@core/lib/firebase';

export async function createAuthUser(email: string, password: string): Promise<string> {
  const secondary = initializeApp(getFirebaseConfig(), `user-creation-${Date.now()}`);
  try {
    const auth = getAuth(secondary);
    const cred = await createUserWithEmailAndPassword(auth, email, password);
    await signOut(auth);
    return cred.user.uid;
  } finally {
    await deleteApp(secondary);
  }
}
